import { useMutation } from '@tanstack/react-query';
import type {
  WithdrawCardBodyRequest,
  WithdrawCardErrorResponse,
  WithdrawSuccessResponse,
} from '@/shared/types';
import { withdrawCard } from '@/features/withdraw-card';

interface UseWithdrawCardOptions {
  onSuccess?: (data: WithdrawSuccessResponse) => void;
  onError?: (error: WithdrawCardErrorResponse) => void;
}

export function useWithdrawCard(options?: UseWithdrawCardOptions) {
  const mutation = useMutation<
    WithdrawSuccessResponse,
    WithdrawCardErrorResponse,
    WithdrawCardBodyRequest
  >({
    mutationFn: withdrawCard,
    onSuccess: options?.onSuccess,
    onError: options?.onError,
  });

  return {
    ...mutation,
  };
}
